import React from "react";
import Footer from "../components/footer/Footer";
import Header from "../components/header/Header";
import Contact from "../components/contactUs/Contact";

function ContactUs() {
  return (
    <>
      <Header />
      <Contact />
      <Footer />
    </>
  );
}

export default ContactUs;
